import '../contact-hours/index.js';
import { RefiFooter } from './footer.component.js';
import { defineRefiElement } from '../../utils/define-refi-element.js';
import '../contact-hours/contact-hours.component.js';
import '../../lit-element.js';
import '../../styles/reset.style.js';
import '../../styles/links.style.js';
import '../../styles/buttons.style.js';
import '../../adobe-target/adobe-target.js';
import '../../utils/load-script.js';
import '../../utils/wait-for-dom.js';
import '../../utils/refi-mfe-uuid.js';
import '../../utils/track-analytics-event.js';

defineRefiElement('refi-common-footer', RefiFooter);
